var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav mr-auto"},[_c('v-btn',{attrs:{"text":"","to":"/"}},[_vm._v("Home")]),_vm._v("| "),_c('v-btn',{attrs:{"text":"","to":"/dashboard"}},[_vm._v("Minifig Identifier")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }